export default __webpack_public_path__ + "static/media/YAS0910.34I-41428_-24751_0.2244bb7c.jpg";